import { get, uploadFile, post } from './api';

export const getArticleByCategory = function(categoryCode) {
    return get('/search/article/byCategoryCode', { categoryCode });
};

export const getArticleById = function(articleId) {
    return get('/search/article/byId', { articleId });
};

export const getArticleList = function(categoryCode, page) {
    return get('/search/article/listByCategoryCode', { categoryCode, page });
};

export const getHotArticle = function() {
    return get('/search/article/hotList');
};

export const getCategoryList = function(topCode) {
    return get('/search/category/childList', { topCode });
};

export const getBrandList = function() {
    return get('/pro/brandList');
};

export const getNews = function() {
    return get('/search/article/hotList');
};

export const getBanner = function(type) {
    return get('/banner/selectList', { type });
};

export const getQqList = function() {
    return get('/config/qqList');
};

export const getProductList = function(type, page, pageSize) {
    return get('/search/product/listByType', { type, page, pageSize });
};

export const getFeaturedList = function(limit, type) {
    return get('/search/product/getFeaturedList', { limit, type });
};

export const getCoa = function(params) {
    return get('/coaSearch/query', params);
};

export const saveProMade = function(params) {
    return uploadFile('/proMadeRequired/save', params);
};

export const saveProIndex = function(params) {
    return post('/proIndexRequired/save', params);
};

export const getProInfoFile = function() {
    return get('/proInfoFile/list');
};

export const getIntegralGoods = function(params) {
    return get('/integralGoods/findPaging', params);
};

export const exchangeGoods = function(params) {
    return post('/integralGoods/exchange', params);
};

export const getNavList = function() {
    return get('/pro/categoryList');
};
